module.exports = __webpack_public_path__ + "img/5.967fa62a.png";